// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Accommodations_wrapper__2loKN","room":"Accommodations_room__cxR2g","videos":"Accommodations_videos__3Fh3L"};